import string from './asStringCell';
import date from './asDateCell';
import custom from './asCustomCell';
import number from './asNumberCell';
import boolean from './asBooleanCell';
import action from './asActionCell';
import link from './asLinkCell';
import checkbox from './asCheckboxCell';

export default {
  string,
  date,
  custom,
  number,
  boolean,
  action,
  link,
  checkbox,
};
